import { RANK_SHIELD_CONFIG } from "../../lib/constants";

export default function RankBadge({ rank }) {
  if (!rank || rank === "none") return null;

  const config = RANK_SHIELD_CONFIG[rank] || RANK_SHIELD_CONFIG.none;

  return (
    <span
      className="inline-flex items-center justify-center font-semibold rounded-full flex-shrink-0"
      style={{
        background: config.gradient,
        color: config.text,
        fontSize: "11px",
        lineHeight: 1,
        letterSpacing: "0.03em",
        padding: "4px 12px",
        border: `1.5px solid ${config.border}`,
        boxShadow: config.animate ? undefined : config.glow,
        animation: config.animate ? "shield-pulse 2.5s ease-in-out infinite" : undefined,
      }}
    >
      {config.label}
    </span>
  );
}
